import { SomeoneReverseMaps } from './Leute/Someone.js';
import { SignatureReverseMaps } from './SignatureRecipes.js';
import { CertificateReverseMaps } from './Certificates/CertificateRecipes.js';
import { ProfileReverseMaps, ProfileReverseMapsForIdObjects } from './Leute/Profile.js';
import { CommunicationEndpointReverseMaps } from './Leute/CommunicationEndpoints.js';
import { ChannelInfoReverseMaps } from './ChannelRecipes.js';
// NOTE: HashGroup, Access, and IdAccess reverse maps are already configured in one.core's
// CORE_RVMAPS (reverse-map-updater.ts) with ['*'] (all properties), so we don't need to add them here.
// This enables determineAccessibleHashes to find:
// - HashGroups containing a person: getAllEntries(person, 'HashGroup')
// - Access objects referencing a HashGroup: getAllEntries(hashGroup, 'Access')
// - IdAccess objects referencing a HashGroup: getAllEntries(hashGroup, 'IdAccess')
export const ReverseMapsExperimental = [
    ...SignatureReverseMaps,
    ...CertificateReverseMaps,
    ...ProfileReverseMaps,
    ...SomeoneReverseMaps,
    ...CommunicationEndpointReverseMaps,
    ...ChannelInfoReverseMaps
];
export const ReverseMapsForIdObjectsExperimental = [
    ...ProfileReverseMapsForIdObjects
];
//# sourceMappingURL=reversemaps-experimental.js.map